import React, { useState, useEffect } from "react";

import { Redirect } from "react-router-dom";

import axios from "axios";
import { server } from "../utills/utils";

import MainNavigation from "../components/Navigations/MainNavigation";
import CartItem from "../components/Cart/CartItem";
import Spinner from "../components/Modals/SpinnerModal";

import { connect } from "react-redux";
import * as actionTypes from "../store/actions/actionTypes";

import styled from "styled-components";

const Container = styled.div`
  width: 80%;
  height: 80vh;
  padding-top: 100px;
  margin-left: 10%;
  @media (max-width: 769px) {
    width: 90%;
    margin-left: 5%;
  }
`;
const Info = styled.div`
  width: 40%;
  height: 100%;
  float: left;
  @media (max-width: 769px) {
    width: 100%;
  }
`;
const CartView = styled.div`
  width: 44%;
  height: 100%;
  float: right;
  @media (max-width: 769px) {
    display: none;
  }
`;
const Title = styled.h2`
  padding: 0;
  margin: 0 0 30px 0;
  font-weight: 500;
  font-size: 1.5em;
`;
const SubTitle = styled.h2`
  padding: 0;
  margin: 10px 0 10px 0;
  font-weight: 500;
  font-size: 1em;
`;
const InputBox = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;
const Input = styled.input`
  width: 95%;
  border: none;
  outline: none;
  padding: 12px 2%;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
`;
const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #276fb7;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;

const Total = styled.div`
  width: 95%;
  height: 20px;
  padding: 5px 0;
`;
const TotalTitle = styled.h3`
  margin: 0;
  padding: 0;
  float: left;
`;
const TotalValue = styled.h3`
  margin: 0;
  padding: 0;
  float: right;
`;
const Carts = styled.div`
  width: 100%;
  height: 80%;
  overflow-y: scroll;
  border-bottom: 2px solid #ccc;
  &::-webkit-scrollbar {
    display: none;
  }
`;
function Checkout(props) {
  let total = 0;
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [redirect, setRedirect] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const phoneChangeHandler = (e) => {
    setPhone(e.target.value);
  };
  const addressChangeHandler = (e) => {
    setAddress(e.target.value);
  };
  let delivery_caharge = props.shop.deliveryCharge
    ? props.shop.deliveryCharge
    : localStorage.delivery_charge
    ? localStorage.delivery_charge
    : 25;
  const orderCreateHandler = async (e) => {
    e.preventDefault();
    // console.log(name, phone, address);
    // console.log(props.cart);
    try {
      setSpinner(true);
      const order = await axios.post(server, {
        query: `
          mutation{
            createOrder(input:{
                shopId:"${localStorage.viewedShop}",
                userToken:"${localStorage.TOKEN}",
                orderedProducts: ${JSON.stringify(props.cart).replace(
                  /"([^(")"]+)":/g,
                  "$1:"
                )},
                deliveryFee:${delivery_caharge}
                address:"${address}",
                contactNumber:"${phone}",
                contactName:"${name}",
                email:"test@gmail.com"
            }){
               success
            }
          }
        `,
      });
      setSpinner(false);
      setRedirect(<Redirect to="/user-profile/orders" />);
      localStorage.removeItem("cart");
      props.setCart([]);

      console.log(order);
    } catch (error) {
      throw error;
    }
  };

  const removeCartItemHandler = (itemId) => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");

    console.log(itemId);
    const newCartItems = cart.filter((cart, id) => {
      return id !== itemId;
    });
    console.log(newCartItems);
    if (newCartItems.length <= 0) {
      setRedirect(<Redirect to={"/shop/" + localStorage.viewedShop} />);
    }
    localStorage.setItem("cart", JSON.stringify(newCartItems));
    props.setCart(newCartItems);
  };

  const cartItemQntDcrHandler = (itemId) => {
    const newCartItems = [];
    JSON.parse(localStorage.getItem("cart") || "[]").map((cart, id) => {
      if (itemId == id) {
        if (cart.quantity > 1) {
          let newQuantity = cart.quantity - 1;
          let cartItem = {
            itemId: cart.itemId,
            quantity: newQuantity,
            price: cart.price,
            image: cart.image,
            name: cart.name,
          };
          newCartItems.push(cartItem);
        } else {
          newCartItems.push(cart);
        }
      } else {
        newCartItems.push(cart);
      }
    });

    localStorage.setItem("cart", JSON.stringify(newCartItems));
    props.setCart(newCartItems);
  };
  const cartItemQntIncHandler = (itemId) => {
    const newCartItems = [];
    JSON.parse(localStorage.getItem("cart") || "[]").map((cart, id) => {
      if (itemId == id) {
        let newQuantity = cart.quantity + 1;
        let cartItem = {
          itemId: cart.itemId,
          quantity: newQuantity,
          price: cart.price,
          image: cart.image,
          name: cart.title,
        };
        newCartItems.push(cartItem);
      } else {
        newCartItems.push(cart);
      }
    });

    localStorage.setItem("cart", JSON.stringify(newCartItems));
    props.setCart(newCartItems);
  };

  let cartItemsNew = props.cart.map((cartItem, id) => {
    total += cartItem.price * cartItem.quantity;
    return (
      <CartItem
        key={id}
        cartItem={cartItem}
        id={id}
        removeCartItemHandler={removeCartItemHandler}
        cartItemQntIncHandler={cartItemQntIncHandler}
        cartItemQntDcrHandler={cartItemQntDcrHandler}
      />
    );
  });
  console.log("Utils", props.utils);
  useEffect(() => {
    if (props.utils.name) {
      setName(props.utils.name);
    }
    if (props.utils.phone) {
      setPhone(props.utils.phone);
    }
    if (props.utils.delivery_address) {
      setAddress(props.utils.delivery_address);
    }
  }, []);
  return (
    <div>
      {redirect}
      <Spinner show={spinner} />
      <MainNavigation />
      <Container>
        <Info>
          <Title>Delivery Details</Title>
          <form onSubmit={orderCreateHandler}>
            <InputBox>
              <SubTitle>Contact name</SubTitle>
              <Input
                type="text"
                placeholder="Contact name"
                value={name}
                onChange={nameChangeHandler}
                required="true"
              />
            </InputBox>
            <InputBox>
              <SubTitle>Contact number</SubTitle>
              <Input
                type="number"
                min="0"
                placeholder="Contact number"
                value={phone}
                onChange={phoneChangeHandler}
                required="true"
              />
            </InputBox>
            <InputBox>
              <SubTitle>Address</SubTitle>
              <Input
                type="text"
                placeholder="Address (Sector no, road no, house no)"
                value={address}
                onChange={addressChangeHandler}
                required="true"
              />
            </InputBox>
            <Button>Place order</Button>
          </form>
        </Info>
        <CartView>
          <Carts>{cartItemsNew}</Carts>
          <Total>
            <TotalTitle>Subtotal</TotalTitle>
            <TotalValue>{total} TK</TotalValue>
          </Total>
          <Total>
            <TotalTitle>Delivery charge</TotalTitle>
            <TotalValue>{delivery_caharge} TK</TotalValue>
          </Total>
          <Total>
            <TotalTitle>Total</TotalTitle>
            <TotalValue>{total + parseInt(delivery_caharge)} TK</TotalValue>
          </Total>
        </CartView>
      </Container>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    cart: state.utils.cart,
    name: state.utils.name,
    utils: state.utils,
    shop: state.utils.shop,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCart: (cart) => {
      dispatch({
        type: actionTypes.SET_CART,
        cart,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
